import axios from 'axios'
import {
  GET_ARCHIVED_POSTDISCHARGES_COUNT,
  GET_ARCHIVED_POSTDISCHARGES_LIST,
  GET_ARCHIVED_POSTDISCHARGE,
  ARCHIVE_POSTDISCHARGE
} from './action-constants'

const TABLENAME = 'archivedpostdischarges'
const TABLENAME_BY_LOGIN_ID =
  'archivedpostdischarges/bylogin' /*** ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME_POSTDISCHARGE_ARCHIVE_POSTDISCHARGE = 'postdischarges/archive'
const TABLENAME_POSTDISCHARGE_COUNT = 'archivedpostdischarges/count'

export function getArchivedPostDischargesCount (loginID) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_POSTDISCHARGE_COUNT + '/' + loginID
  return {
    type: GET_ARCHIVED_POSTDISCHARGES_COUNT,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getArchivedPostDischargesList (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_BY_LOGIN_ID + '/' + loginID
  return {
    type: GET_ARCHIVED_POSTDISCHARGES_LIST,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getArchivedPostDischarge (id) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id
  return {
    type: GET_ARCHIVED_POSTDISCHARGE,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function archivePostDischarge (id, params) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_POSTDISCHARGE_ARCHIVE_POSTDISCHARGE + '/' + id
  return {
    type: ARCHIVE_POSTDISCHARGE,
    payload: new Promise((resolve, reject) => {
      axios
        .post(JSONURL, params)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
